// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `"Open Sans", sans-serif`,
  },
});

export default theme;
